'use strict';

var React = require('react');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./pinterest.scss');
}

const Pinterest = ({ pinterest, style }) => {
    const href = `https://www.pinterest.com/pin/create/button/?url=${pinterest.url}&media=${pinterest.media}&description=`;

    return (
        <div className='co-pin' style={style}>
            <a data-pin-do    = "buttonPin"
               data-pin-tall  = "true"
               data-pin-round = "true"
               data-pin-save  = "false"
               href           = {href}>
                 <img src="//assets.pinterest.com/images/pidgets/pinit_fg_en_round_red_32.png" alt="pinterest pin" width="32" height="32"/>
            </a>
        </div>
    );
}

module.exports = Pinterest;



// WEBPACK FOOTER //
// ./src/components/pinterest.jsx